import { createFeature, createReducer, on } from "@ngrx/store";
import { DownloadStatementFormOptions, StatementDates, StatementDocument, StatementError } from "../../interfaces";
import * as DownloadStatementFormActions from './download-statement-form.actions';

/**
* Initial state of the Personal Information Data.
* 
* @const initialState
*/
const initialState: DownloadStatementFormOptions = {
    statementDocument: {
        fileName: '',
        fileData: ''
    },
    statementDates: {
        startDate: '',
        endDate: '',
        includeLeaseBuyout: true
    },
    statementError: {
        errorCode: '',
        message: '',
        requestId: '',
        serviceCode: ''
    },
    loading: false,
    isSubmittingSuccess: false,
    isSubmittingError: false
};

const postDownloadStatementDataFunction: any =
    (state: DownloadStatementFormOptions, action: { statementDates: StatementDates }) => ({ ...state, statementDates: { ...action }, loading: true, isSubmittingSuccess: false, isSubmittingError: false });

const postDownloadStatementDataSuccessFunction: any =
    (state: DownloadStatementFormOptions, action: { statementDocument: StatementDocument }) => ({ ...state, statementDocument: { ...action.statementDocument }, loading: false, isSubmittingSuccess: true, isSubmittingError: false });

const postDownloadStatementDataErrorFunction: any =
    (state: DownloadStatementFormOptions, error: { error: StatementError }) => ({ ...state, statementError: { ...error.error }, loading: false, isSubmittingSuccess: false, isSubmittingError: true });

const resetSubmittingDownloadStatementFormFunction: any =
    (state: DownloadStatementFormOptions) => ({ ...initialState });

const DownloadStatementFormReducer = createReducer(
    initialState,
    on(DownloadStatementFormActions.postDownloadStatementData, postDownloadStatementDataFunction),
    on(DownloadStatementFormActions.postDownloadStatementDataSuccess, postDownloadStatementDataSuccessFunction),
    on(DownloadStatementFormActions.postDownloadStatementDataError, postDownloadStatementDataErrorFunction),
    on(DownloadStatementFormActions.resetSubmittingDownloadStatementForm, resetSubmittingDownloadStatementFormFunction)
);

/**
 * Reducer function to handle state transitions for Personal Iformation Data 
 * feature.
 * 
 * @const DownloadStatementFormFeature
 */
export const DownloadStatementFormFeature = createFeature({
    name: 'downloadStatementForm',
    reducer: DownloadStatementFormReducer
});